/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core'

// avoid name collisions by prefixing
export const LOCAL_STORAGE_KEY_PREFIX = 'cloudcycle-'
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  constructor() {}

  public setItem(key: string, data: any): void {
    localStorage.setItem(this.prefixKey(key), JSON.stringify(data))
  }

  public getItem(key: string): any {
    const prefixedKey = this.prefixKey(key)
    try {
      return JSON.parse(localStorage.getItem(prefixedKey))
    } catch (e) {
      console.log('Error getting value from local storage for ' + prefixedKey)
      return null
    }
  }

  public removeItem(key: string): void {
    localStorage.removeItem(this.prefixKey(key))
  }

  public clear() {
    localStorage.clear()
  }

  private prefixKey(key: string) {
    return `${LOCAL_STORAGE_KEY_PREFIX}${key}`
  }
}
